import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseUtilsService } from '@fuse/services/utils';
import { Subject, takeUntil } from 'rxjs';
import { LightboxService } from '@core/services/lightbox.service';
import { DealerDataService } from '../../dealer-data.service';

@Component({
  selector: 'ade-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class AdeContentComponent implements OnChanges, OnDestroy {
  @Input() slug: string;

  page: any = null;
  isLoading = true;
  isScreenSmall = false;

  private _unsub = new Subject<void>();

  constructor(
    private _svc: DealerDataService,
    private _lightboxService: LightboxService,
    private _utilService: FuseUtilsService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
  ) {
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsub))
      .subscribe(({ matchingAliases }) => {
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slug'] && this.slug) {
      this._load();
    }
  }

  private _load(): void {
    this.isLoading = true;
    this.page = null;
    this._svc
      .getPage(this.slug)
      .pipe(takeUntil(this._unsub))
      .subscribe({
        next: (r: any) => {
          const items = r?.data;
          const raw = Array.isArray(items) ? items[0] : items;
          this.page = raw?.attributes ?? null;
          this.isLoading = false;
          this._lightboxService.refresh();
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  ngOnDestroy(): void {
    this._unsub.next();
    this._unsub.complete();
  }

  getResponsiveClasses(widget: any): string {
    if (!widget?.Columns) return 'w-full col-span-1 md:col-span-12';
    if (this.isScreenSmall) return 'col-span-1';
    const colClasses = this._utilService.generateResponsiveClass(
      widget.Columns,
    );
    return `${widget.__component.replace('.', '_')} ${colClasses}`;
  }
}
